
    <div #topDiv *ngIf="!(isSmallScreenSubject | async)" class="position-relative">

        <button         
            *ngIf="expandedSubject | async;else regularBtn"    
            mat-icon-button
            class="primary-contrast-text light-bold position-top-right-smaller z-10000 no-padding-mat-icon-button" 
            (click)="toggleExpanded()"
        >            
            <mat-icon fontSet="symbols" class="primary-contrast-text">side_navigation</mat-icon>
        </button>         
        <ng-template #regularBtn>
            <button mat-icon-button (click)="toggleExpanded()">
                <mat-icon  fontSet="symbols" class="primary-contrast-text">side_navigation</mat-icon>
            </button>

        </ng-template>
    </div>
        
    <ss-sidenav-tree 
        *ngIf="expandedSubject | async;else collapsedSidenavTree"
        class="display-block padding-standard-bottom"
        fixedScroll
        [otherElements]="otherElementsSubject | async"
        [additionalOffset]="16"
    ></ss-sidenav-tree>

    <ng-template #collapsedSidenavTree>
        <button 
            mat-icon-button 
            [matTooltip]=""
            class="display-block primary-contrast-text"
            [matMenuTriggerFor]="sidenavTreeMenu"
            
            
        >
            <mat-icon>menu</mat-icon>
        </button>
    </ng-template>

    <mat-menu #sidenavTreeMenu >

        <div class="border-radius-smaller padding-small-block" > 
            <ss-sidenav-tree class="col-width"></ss-sidenav-tree>
        </div>
        
    </mat-menu>


